<style scoped>

  .action-button {
    min-width: 120px;
  }

  @media only screen and (max-width: 1160px) {
    .action-button {
      margin-top: 10px !important;
    }
    .ui.divider {
      margin-bottom: 5px !important;
    }
  }

</style>

<template>
  
  <div>
     
    <button v-for="(button, index) in buttons" :key="index" class="ui small button m-r-10 action-button"
      :class="{ loading: (performingAction == button.action), disabled: (performingAction && performingAction != button.action) }"
      @click="onAction(button.action)">
      <i :class="button.icon + ' ' + button.color"></i> {{ button.label }}
    </button>

  </div>

</template>

<script>

  export default {
    
    data() {
      return {
        buttons: [],
      }
    },

    props: ["quotation", "performingAction"],

    watch: {

      "quotation.status" () {
        this.loadButtons()
      },
    },

    created() {
      this.loadButtons()      
    },

    methods: {

      loadButtons() {

        this.buttons = []

        if (this.quotation.canceled) {
          this.buttons.push({ label: "Ativar", color: "green", icon: "sync icon", action: "activate" })
        }
        
        if (this.quotation.isRevision) {
          this.buttons.push({ label: "Imprimir", color: "blue", icon: "print icon", action: "print" })
          return
        }

        if (this.quotation.isOwner && this.quotation.underMaintenance)  
          this.buttons.push({ label: "Finalizar", color: "green", icon: "check icon", action: "finish" })

        if (this.quotation.isOwner && this.quotation.waitingConfirm)  
          this.buttons.push({ label: "Confirmar", color: "green", icon: "check circle icon", action: "confirm" })  

        if ((this.$isApprover() && (this.quotation.waitingApproval || this.quotation.waitingTecnicalApproval) ) || 
         (this.quotation.approvingly && this.$isApprover() && this.$store.state.user.approverProfile.canStealApproval && 
          this.$store.state.user.id != this.quotation.approver.id))  
          this.buttons.push({ label: "Assumir aprovação", color: "teal", icon: "magic icon", action: "take_approval" })  

        if (this.quotation.isApprover && (this.quotation.approvingly || this.quotation.waitingTecnicalApproval)) {
          this.buttons.push({ label: "Aprovar", color: "green", icon: "thumbs up icon", action: "approve" })
          this.buttons.push({ label: "Não aprovar", color: "red", icon: "thumbs down icon", action: "disapprove" })
          this.buttons.push({ label: "Desistir de aprovar", color: "orange", icon: "undo icon", action: "giveup" })
        }

        if (this.quotation.canRequestTecnicalApproval)
          this.buttons.push({ label: "Aprovação técnica", color: "black", icon: "cogs icon", action: "technical_approval" })            

        if (this.quotation.isApprover && (this.quotation.waitingConfirm || this.quotation.notApproved || this.quotation.tecnicalReject))
          this.buttons.push({ label: "Desfazer decisão", color: "orange", icon: "undo icon", action: "undo" })        

        if (this.quotation.allowUpdate)
          this.buttons.push({ label: "Alterar", color: "teal", icon: "pencil square icon", action: "update" })
          if (this.quotation.codeCustomer === '000000' &&  this.quotation.unitCustomer === '00' && !this.quotation.canceled) {
            this.buttons.push({ label: "Transf.Padrão", color: "green", icon: "paste icon", action: "transpadrao" })
          }
        if (this.quotation.canPrint)
          this.buttons.push({ label: "Imprimir", color: "blue", icon: "print icon", action: "print" })                                      

        if (this.quotation.isApprover && (this.quotation.approvingly || this.quotation.waitingConfirm || 
            this.quotation.notApproved || this.quotation.tecnicalReject || this.quotation.waitingTecnicalApproval)) {

          if (this.quotation.canEdit) {
            this.buttons.push({ label: "Bloquear", color: "red", icon: "lock icon", action: "lock" })
          } else {
            this.buttons.push({ label: "Desbloquear", color: "grey", icon: "unlock icon", action: "unlock" })
          }
        }

        if ((this.quotation.isOwner || this.quotation.isApprover) && !this.quotation.underMaintenance && 
            !this.quotation.confirmed && !this.quotation.processing && !this.quotation.canceled && 
            !this.quotation.isRevision && !this.quotation.approvingly)
          this.buttons.push({ label: "Cancelar", color: "red", icon: "times icon", action: "cancel" })  

        if (this.quotation.underMaintenance && (this.quotation.isOwner || this.$isApprover()))
          this.buttons.push({ label: "Excluir", color: "red", icon: "times icon", action: "delete" })
      },

      onAction(action) {
        this.$emit("onAction", action)
      },
    },
  }

</script>

